<template>
    <el-button
        v-if="permissionsShow"
        :size="size"
        @click="_click"
        :type="type === 'button' ? 'default' : type"
        :loading="loading"
        :disabled="disabled"
        :round="round"
        :circle="circle"
        :autofocus="autofocus"
        :icon="icon"
        :native-type="nativeType"
        :class="this.size == 'medium' ? 'mediumWidth' : null"
    >
        <slot></slot>
    </el-button>
</template>

<script>
export default {
    // 接收父组件的参数
    props: {
        // 大小属性可选择为medium/small/mini,平台统一设置为medium
        size: {
            type: String,
            default: function() {
                return 'medium';
            }
        },
        // 类型分为primary和默认两种,添加可选择为primary，其余统一为默认
        type: {
            type: String,
            default: function() {
                return 'default';
            }
        },
        //是否朴素按钮
        plain: Boolean,
        // 是否为加载状态，false/true
        loading: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否禁用 false/true
        disabled: Boolean,
        /* 是否圆角按钮 */
        round: Boolean,
        /* 是否圆形按钮 */
        circle: Boolean,
        /* button图例 */
        icon: {
            type: String,
            default: ''
        },
        /* 是否默认聚焦 */
        autofocus: Boolean,
        /* 原生 type 属性 */
        nativeType: {
            type: String,
            default: 'button'
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true
        };
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
            this.$emit('getPermissionsStatus', this.permissionsShow);
        }
    },
    // 实时监听父组件的值
    watch: {
        loading(newValue) {
            this.loading = newValue;
        },
        disabled(newValue) {
            this.disabled = newValue;
        },
        permissions: {
            handler: function(val) {
                this._permissionChange(val);
            },
            // immediate表示在watch中首次绑定的时候，是否执行handler，值为true则表示在watch中声明的时候，就立即执行handler方法，
            // 值为false，则和一般使用watch一样，在数据发生变化的时候才执行handler。
            immediate: true
        }
    },
    methods: {
        _permissionChange(val) {
            /* 权限数据处理 */
            if (val.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
                this.permissionsShow = this.dealPermissions(val, this.roles, this.oneOfPermissions);
            }
        },
        /* 子组件内部处理click事件然后向外发送click事件 */
        _click: function() {
            this.$emit('click');
        }
    }
};
</script>
<style>
.mediumWidth {
    min-width: 100px;
}
</style>
